// document.addEventListener('DOMContentLoaded', function() {
//     // Function to calculate new review count
//     function calculateNewReviewCount(currentCount) {
//         const minCount = 390;
//         const maxCount = 946;
//         // Multiply by a factor to scale up, ensuring > 1000 and <= 3000
//         let newCount = Math.floor(currentCount * 10);
//         // Ensure the new count is within bounds
//         if (newCount <= minCount) {
//             newCount = minCount + (currentCount % 100); // Add some variation
//         } else if (newCount > maxCount) {
//             newCount = maxCount;
//         }
//         return newCount;
//     }

//     // Update Block 1: .scm-reviews-rate and text
//     const reviewRateDiv = document.querySelector('.scm-reviews-rate');
//     if (reviewRateDiv) {
//         // Get the data-rate-version2 attribute
//         const dataRate = reviewRateDiv.getAttribute('data-rate-version2');
//         let rateData;
//         try {
//             rateData = JSON.parse(dataRate);
//         } catch (e) {
//             console.error('Error parsing data-rate-version2:', e);
//             return;
//         }

//         const currentTotal = parseInt(rateData.total, 10);
//         const newTotal = calculateNewReviewCount(currentTotal);

//         // Scale the rating counts proportionally
//         const scaleFactor = newTotal / currentTotal;
//         rateData.rate1 = Math.round(rateData.rate1 * scaleFactor);
//         rateData.rate2 = Math.round(rateData.rate2 * scaleFactor);
//         rateData.rate3 = Math.round(rateData.rate3 * scaleFactor);
//         rateData.rate4 = Math.round(rateData.rate4 * scaleFactor);
//         rateData.rate5 = Math.round(rateData.rate5 * scaleFactor);
//         rateData.total = newTotal;

//         // Update the data-rate-version2 attribute
//         reviewRateDiv.setAttribute('data-rate-version2', JSON.stringify(rateData));

//         // Update the text content (e.g., "Excellent 4.8 | 278 review")
//         const textElement = reviewRateDiv.querySelector('.lai-wrap-block-star').nextSibling;
//         if (textElement && textElement.nodeType === Node.TEXT_NODE) {
//             const textParts = textElement.textContent.split('|');
//             if (textParts.length === 2) {
//                 textElement.textContent = `${textParts[0].trim()} | ${newTotal} review${newTotal !== 1 ? 's' : ''}`;
//             }
//         }
//     }

//     // Update Block 2: #total-review spans
//     const totalReviewSpans = document.querySelectorAll('#total-review');
//     totalReviewSpans.forEach(span => {
//         const currentCount = parseInt(span.textContent, 10);
//         const newCount = calculateNewReviewCount(currentCount);
//         span.textContent = newCount;
//     });
// });


// ============ 2nd edition ======================

document.addEventListener('DOMContentLoaded', function() {
    // Constants for review count boundaries
    const MIN_REVIEWS = 2000;
    const MAX_REVIEWS = 7000;
    const STORAGE_PREFIX = 'productReviews_';
    
    /**
     * Gets a unique identifier for the current product
     * @returns {string} - Unique product identifier
     */
    function getProductIdentifier() {
        // Try multiple methods to get a unique product identifier
        
        // Method 1: Check for product ID in URL
        const urlParams = new URLSearchParams(window.location.search);
        const productId = urlParams.get('product_id') || urlParams.get('id');
        if (productId) return `product_${productId}`;
        
        // Method 2: Extract from URL path (for /products/product-handle URLs)
        const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        if (pathMatch) return `handle_${pathMatch[1]}`;
        
        // Method 3: Look for product data in meta tags
        const productMeta = document.querySelector('meta[property="product:id"]') || 
                           document.querySelector('meta[name="product-id"]');
        if (productMeta) return `meta_${productMeta.content}`;
        
        // Method 4: Look for product data in script tags (Shopify format)
        const scriptTags = document.querySelectorAll('script[type="application/ld+json"]');
        for (let script of scriptTags) {
            try {
                const data = JSON.parse(script.textContent);
                if (data.sku) return `sku_${data.sku}`;
                if (data.productID) return `id_${data.productID}`;
            } catch (e) {
                // Continue to next script tag
            }
        }
        
        // Method 5: Look for LAI app product identifier
        const laiElement = document.querySelector('[data-lai-product-id]');
        if (laiElement) return `lai_${laiElement.getAttribute('data-lai-product-id')}`;
        
        // Method 6: Use page title as fallback (cleaned)
        const pageTitle = document.title.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 50);
        if (pageTitle) return `title_${pageTitle}`;
        
        // Method 7: Use URL as ultimate fallback
        return `url_${btoa(window.location.pathname).substring(0, 20)}`;
    }
    
    /**
     * Gets stored review data for a specific product or generates new data
     * @param {string} productId - Unique product identifier
     * @returns {Object} - Object containing review counts
     */
    function getProductReviewData(productId) {
        const storageKey = STORAGE_PREFIX + productId;
        
        try {
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                const data = JSON.parse(stored);
                // Validate stored data structure
                if (data.totalReviews && data.individualRatings && data.productId === productId) {
                    return data;
                }
            }
        } catch (e) {
            console.warn('Error reading stored review data for product:', productId, e);
        }
        
        // Generate new data if none exists or is invalid
        return generateProductReviewData(productId);
    }
    
    /**
     * Generates new random review data for a specific product and stores it permanently
     * @param {string} productId - Unique product identifier
     * @returns {Object} - Object containing generated review counts
     */
    function generateProductReviewData(productId) {
        // Use product ID as seed for consistent randomness per product
        const seed = hashCode(productId);
        const rng = seededRandom(seed);
        
        const data = {
            productId: productId,
            totalReviews: Math.floor(rng() * (MAX_REVIEWS - MIN_REVIEWS + 1)) + MIN_REVIEWS,
            individualRatings: {},
            generated: Date.now()
        };
        
        // Generate individual rating counts that add up to total
        const total = data.totalReviews;
        const ratings = [0, 0, 0, 0, 0]; // ratings[0] = 1-star, ratings[4] = 5-star
        
        // Distribute ratings with bias towards higher ratings (more realistic)
        // Use seeded random for consistency
        const baseWeights = [0.03, 0.05, 0.12, 0.35, 0.45]; // Favor 4-5 star reviews
        const weights = baseWeights.map(w => w + (rng() - 0.5) * 0.1); // Add some variation
        
        // Normalize weights to sum to 1
        const weightSum = weights.reduce((a, b) => a + b, 0);
        const normalizedWeights = weights.map(w => w / weightSum);
        
        for (let i = 0; i < 5; i++) {
            ratings[i] = Math.round(total * normalizedWeights[i]);
        }
        
        // Adjust for rounding errors
        const sum = ratings.reduce((a, b) => a + b, 0);
        const diff = total - sum;
        ratings[4] += diff; // Add difference to 5-star ratings
        
        // Ensure no negative values
        for (let i = 0; i < 5; i++) {
            if (ratings[i] < 0) {
                ratings[4] += ratings[i];
                ratings[i] = 0;
            }
        }
        
        // Store individual ratings
        for (let i = 1; i <= 5; i++) {
            data.individualRatings[`rate${i}`] = Math.max(0, ratings[i - 1]);
        }
        
        // Store the data permanently (no expiry for product-specific data)
        try {
            const storageKey = STORAGE_PREFIX + productId;
            localStorage.setItem(storageKey, JSON.stringify(data));
        } catch (e) {
            console.warn('Could not store review data for product:', productId, e);
        }
        
        return data;
    }
    
    /**
     * Creates a hash code from a string (for seeding random number generator)
     * @param {string} str - String to hash
     * @returns {number} - Hash code
     */
    function hashCode(str) {
        let hash = 0;
        if (str.length === 0) return hash;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32-bit integer
        }
        return Math.abs(hash);
    }
    
    /**
     * Seeded random number generator (for consistent randomness per product)
     * @param {number} seed - Seed value
     * @returns {function} - Random number generator function
     */
    function seededRandom(seed) {
        let state = seed;
        return function() {
            state = (state * 1664525 + 1013904223) % Math.pow(2, 32);
            return state / Math.pow(2, 32);
        };
    }
    
    /**
     * Updates the review data in the rating element
     * @param {HTMLElement} reviewRateDiv - The element containing review data
     * @param {Object} reviewData - The persistent review data
     */
    function updateReviewData(reviewRateDiv, reviewData) {
        const dataRate = reviewRateDiv.getAttribute('data-rate-version2');
        let rateData;
        
        try {
            rateData = JSON.parse(dataRate);
        } catch (e) {
            console.error('Error parsing data-rate-version2:', e);
            return;
        }
        
        // Check if LAI app has real reviews (don't override if actual reviews exist)
        const currentTotal = parseInt(rateData.total, 10);
        const hasRealReviews = currentTotal > 0 && rateData.hasOwnProperty('real_reviews');
        
        if (hasRealReviews) {
            console.log('Real reviews detected, not overriding for product:', reviewData.productId);
            return;
        }
        
        const newTotal = reviewData.totalReviews;
        
        // Use stored individual ratings
        for (let i = 1; i <= 5; i++) {
            rateData[`rate${i}`] = reviewData.individualRatings[`rate${i}`];
        }
        rateData.total = newTotal;
        
        // Update the element's data
        reviewRateDiv.setAttribute('data-rate-version2', JSON.stringify(rateData));
        
        // Update the visible text
        const textElement = reviewRateDiv.querySelector('.lai-wrap-block-star')?.nextSibling;
        if (textElement?.nodeType === Node.TEXT_NODE) {
            const textParts = textElement.textContent.split('|');
            if (textParts.length === 2) {
                textElement.textContent = `${textParts[0].trim()} | ${newTotal} review${newTotal !== 1 ? 's' : ''}`;
            }
        }
    }
    
    /**
     * Observer to watch for LAI app updates and preserve real review counts
     */
    function setupLAIObserver(productId) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && 
                    mutation.attributeName === 'data-rate-version2') {
                    
                    const element = mutation.target;
                    const dataRate = element.getAttribute('data-rate-version2');
                    
                    try {
                        const rateData = JSON.parse(dataRate);
                        // If LAI app updates with real reviews, update our stored data
                        if (rateData.total > 0 && rateData.real_reviews === true) {
                            const storageKey = STORAGE_PREFIX + productId;
                            const storedData = JSON.parse(localStorage.getItem(storageKey) || '{}');
                            
                            storedData.totalReviews = parseInt(rateData.total, 10);
                            storedData.hasRealReviews = true;
                            
                            for (let i = 1; i <= 5; i++) {
                                storedData.individualRatings[`rate${i}`] = parseInt(rateData[`rate${i}`], 10);
                            }
                            
                            localStorage.setItem(storageKey, JSON.stringify(storedData));
                            console.log('Updated stored data with real reviews for product:', productId);
                        }
                    } catch (e) {
                        // Ignore parsing errors
                    }
                }
            });
        });
        
        const targetElement = document.querySelector('.scm-reviews-rate');
        if (targetElement) {
            observer.observe(targetElement, { attributes: true });
        }
    }
    
    // Get unique product identifier
    const productId = getProductIdentifier();
    console.log('Product ID identified as:', productId);
    
    // Get or generate persistent review data for this specific product
    const reviewData = getProductReviewData(productId);
    console.log('Review data for product:', productId, reviewData);
    
    // Update Block 1: .scm-reviews-rate and text
    const reviewRateDiv = document.querySelector('.scm-reviews-rate');
    if (reviewRateDiv) {
        updateReviewData(reviewRateDiv, reviewData);
    }
    
    // Update Block 2: #total-review spans
    document.querySelectorAll('#total-review').forEach(span => {
        const currentCount = parseInt(span.textContent, 10) || 0;
        
        // Don't override if there are real reviews
        if (currentCount > 0 && reviewData.hasRealReviews) {
            return;
        }
        
        span.textContent = reviewData.totalReviews;
    });
    
    // Setup observer to watch for LAI app updates
    setupLAIObserver(productId);
    
    // Debug functions (remove in production)
    window.getProductReviewData = () => reviewData;
    window.clearProductReviewData = () => {
        localStorage.removeItem(STORAGE_PREFIX + productId);
        location.reload();
    };
    window.listAllProductReviews = () => {
        const keys = Object.keys(localStorage).filter(key => key.startsWith(STORAGE_PREFIX));
        const data = {};
        keys.forEach(key => {
            data[key] = JSON.parse(localStorage.getItem(key));
        });
        return data;
    };
});